import accountIcon from 'images/knowledge-center/category-account.png';
import bettingIcon from 'images/knowledge-center/category-betting.png';
import bonusesPromoIcon from 'images/knowledge-center/category-bonuses-promo.png';
import casinoIcon from 'images/knowledge-center/category-casino.png';
import depositsIcon from 'images/knowledge-center/category-deposits.png';
import withdrawalsIcon from 'images/knowledge-center/category-withdrawals.png';

const FAQ_CATEGORY_ICONS: Record<string, string> = {
    account: accountIcon,
    betting: bettingIcon,
    bonuses_promo: bonusesPromoIcon,
    casino: casinoIcon,
    deposits: depositsIcon,
    withdrawals: withdrawalsIcon
};

export const getFaqCategoryIcon = (categoryKey: string): string | null => {
    const icon = FAQ_CATEGORY_ICONS[categoryKey];

    if (!icon && process.env.NODE_ENV !== 'production') {
        console.warn(`Missing FAQ category icon for key: ${categoryKey}`);
    }

    return icon ?? null;
};
